import { useAuth } from "./AuthProvider";
import {useLocation, Navigate, Outlet} from 'react-router-dom';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const storedToken =
    sessionStorage.getItem("adminToken") ||
    localStorage.getItem("adminToken");
  const isAuthenticated = Boolean(user?.token || storedToken);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!isAuthenticated) {
    return (
      <Navigate to="/admin/administrator" state={{ from: location }} replace />
    );
  }
  return <Outlet />;
};

export const PublicRoute = () => {
  const { user, loading } = useAuth();
  const location = useLocation();
  const storedToken =
    sessionStorage.getItem("adminToken") ||
    localStorage.getItem("adminToken");
  const isAuthenticated = Boolean(user?.token || storedToken);

  if (loading) {
    return <div>Loading...</div>;
  }

  // If user is already logged in and trying to access login page, redirect to dashboard
  if (
    isAuthenticated &&
    (location.pathname === "/admin/administrator" ||
      location.pathname === "/admin/register")
  ) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
